export const LINKS = {
  stock_management: "/stock-management",
  orders: "/orders",
  product_information: "/product-information",
  new_product: "/new-products",
  product_prices: "/product-prices",
}